const Small = 'small'
const Medium = 'medium'
const Large = 'large'
const ExtraLarge = 'extralarge'

export default { Small, Medium, Large, ExtraLarge }
